import { useParams } from "react-router-dom";
import React, { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Addsonsection = () =>{
    const [photo, setPhoto] = useState('');
    const [son_id, setSon_id] = useState('');
    const [name, setName] = useState('');
    let { id } =  useParams();

    let navigt = useNavigate();
    const handleImage =(e)=>{
        setName(e.target.files[0]) 
    }
    const  formSubmit = (e)=>{
        e.preventDefault()
        const formData = new FormData()
        formData.append('photo', photo)
        formData.append('son_id', son_id)
        formData.append('name', name)
 
        axios.post('https://backend.dasta.net/api/auth/addsonsectionwokautomatic',formData ).then((res)=>{
            console.log(res)
        }).then((data)=>{
            navigt(-1);
        })
    }  

    return(
        <>
        <form onSubmit={formSubmit}>
            <input type="file" name="file" onChange={(e)=>setPhoto(e.target.files[0])}/>   
                <label>Please Enter Name::</label>
                <input type="text" id="fname" name="fname" onChange={(e)=>setName(e.target.value)}/>
               
                <label>Please Enter number::{id}</label>
                <input type="text" id="fname" name="fname" onChange={(e)=>setSon_id(e.target.value)}/>
            <button type='submit' >submit</button>
        </form>
        </>
    )

}
export default Addsonsection;